// src/ManageProducts.js
import React, { useState, useEffect } from 'react';

function ManageProducts() {
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({
    id: "",
    name: "",
    description: "",
    price: "",
    image_url: "",
    category: ""
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Fetch products on mount.
  useEffect(() => {
    fetch("https://auth.fnrewards.com/api/admin/products", {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setProducts(data.products))
      .catch(err => setError(err.message));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await fetch("https://auth.fnrewards.com/api/admin/products", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Failed to create product");
      } else {
        setMessage(data.message);
        // Refresh products.
        const updated = await fetch("https://auth.fnrewards.com/api/admin/products", {
          method: "GET",
          credentials: "include"
        });
        const updatedData = await updated.json();
        setProducts(updatedData.products);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEdit = async (product) => {
    // Populate form with product data.
    setForm({
      id: product.id,
      name: product.name,
      description: product.description,
      price: product.price,
      image_url: product.image_url || "",
      category: product.category || ""
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await fetch("https://auth.fnrewards.com/api/admin/products", {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Failed to update product");
      } else {
        setMessage(data.message);
        // Refresh products.
        const updated = await fetch("https://auth.fnrewards.com/api/admin/products", {
          method: "GET",
          credentials: "include"
        });
        const updatedData = await updated.json();
        setProducts(updatedData.products);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`https://auth.fnrewards.com/api/admin/products?id=${id}`, {
        method: "DELETE",
        credentials: "include"
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Failed to delete product");
      } else {
        setMessage(data.message);
        // Refresh products.
        const updated = await fetch("https://auth.fnrewards.com/api/admin/products", {
          method: "GET",
          credentials: "include"
        });
        const updatedData = await updated.json();
        setProducts(updatedData.products);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Manage Products</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {message && <p style={{ color: "green" }}>{message}</p>}
      <h2>Create / Edit Product</h2>
      <form onSubmit={form.id ? handleUpdate : handleCreate}>
        {form.id && <p>Editing product ID: {form.id}</p>}
        <div>
          <label>Name:</label>
          <input name="name" value={form.name} onChange={handleChange} required />
        </div>
        <div>
          <label>Description:</label>
          <input name="description" value={form.description} onChange={handleChange} />
        </div>
        <div>
          <label>Price (credits):</label>
          <input name="price" type="number" value={form.price} onChange={handleChange} required />
        </div>
        <div>
          <label>Image URL:</label>
          <input name="image_url" value={form.image_url} onChange={handleChange} />
        </div>
        <div>
          <label>Category:</label>
          <input name="category" value={form.category} onChange={handleChange} />
        </div>
        <button type="submit">{form.id ? "Update Product" : "Create Product"}</button>
      </form>

      <h2>Current Products</h2>
      <ul>
        {products.map(product => (
          <li key={product.id}>
            <strong>{product.name}</strong> – {product.description} | Price: {product.price} credits
            <br />
            <button onClick={() => handleEdit(product)}>Edit</button>
            &nbsp;
            <button onClick={() => handleDelete(product.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ManageProducts;